<app-page-bar></app-page-bar>

<app-page>

  <section *ngIf="leadSource">

    <mat-card class="app-card">
      <mat-card-header>
        <mat-card-title>{{leadSource.isNew() ? "New Lead Source" : leadSource.name}}</mat-card-title>
        <mat-card-subtitle *ngIf="!leadSource.isNew()">Created {{leadSource.created|date}}</mat-card-subtitle>
      </mat-card-header>
    </mat-card>

    <mat-card class="app-card">
      <mat-card-header>
        <mat-card-title>Information</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="form" id="lead-source" (ngSubmit)="saveLeadSource()" novalidate>
          <div class="form-grid">
            <mat-form-field floatLabel="never">
              <input matInput placeholder="Name" formControlName="name" [readonly]="!editMode" appAutofocus />
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>

      <mat-card-actions align="end">
        <button type="button" mat-button color="primary" *ngIf="!editMode" (click)="editLeadSource()">Edit</button>
        <button type="submit" mat-button color="primary" *ngIf="editMode" form="lead-source" [disabled]="!form.valid">Save</button>
        <button type="reset" mat-button *ngIf="editMode" (click)="revertLeadSource()">Cancel</button>
      </mat-card-actions>

    </mat-card>

  </section>

</app-page>
